import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useCloseCareProviderPermanentlyMutation as useCloseCareProviderPermanentlyMutationType } from "@/modules/care-provider/components/edit-care-provider/services/__generated__/useCloseCareProviderPermanentlyMutation.graphql"

const mutation = graphql`
  mutation useCloseCareProviderPermanentlyMutation($input: Ch_updateCareProviderPermanentlyCloseInput!) {
    ch_updateCareProviderPermanentlyClose(input: $input) {
      careProvider {
        id
      }
    }
  }
`

export const useCloseCareProviderPermanentlyMutation = () => {
  return useMutationWithErrorToast<useCloseCareProviderPermanentlyMutationType>(mutation)
}
